import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import store from '@/store/store'
import { computed, ComputedRef } from 'vue'

interface ReturnUseUser {
  isLexonUser: ComputedRef<boolean>
  isDMSUser: ComputedRef<boolean>
  isPortalUser: ComputedRef<boolean>
  isFactureUser: ComputedRef<boolean>
  authToken: ComputedRef<string>
  userId: ComputedRef<string>
}

export default function useUser(): ReturnUseUser {
  const isLexonUser: ComputedRef<boolean> = computed(
    () => store.getters[`${ ModuleNamespaces.AUTH }/getIsLexonUser`]
  )
  const isDMSUser: ComputedRef<boolean> = computed(
    () => store.getters[`${ ModuleNamespaces.AUTH }/getIsLexonDmsUser`]
  )
  const isPortalUser: ComputedRef<boolean> = computed(
    () => store.getters[`${ ModuleNamespaces.AUTH }/getIsPortalUser`]
  )
  const isFactureUser: ComputedRef<boolean> = computed(
    () => store.getters[`${ ModuleNamespaces.AUTH }/getIsFactureUser`]
  )
  const userId: ComputedRef<string> = computed(
    () => store.getters[`${ ModuleNamespaces.AUTH }/getUserId`]
  )

  const authToken = computed(() => store.getters[`${ ModuleNamespaces.AUTH }/getAuthToken`])

  return {
    isLexonUser,
    isDMSUser,
    isPortalUser,
    isFactureUser,
    authToken,
    userId
  }
}
